<div class="wrapper">
  <div class="header">
    <h2 class="cooper">{{ data.title ?? 'Acheter un parcours' }}</h2>
    <p *ngIf="data.message" class="message">{{ data.message }}</p>
  </div>

  <div class="choices">
    <button class="choice-card" type="button" (click)="selectJourney(DynamicType.SPEECH)">
      <span class="choice-label">Parole en groupe</span>
      <span class="choice-caption">Checkout Sellsy dédié</span>
    </button>

    <button class="choice-card" type="button" (click)="selectJourney(DynamicType.COACHING)">
      <span class="choice-label">Coaching en groupe</span>
      <span class="choice-caption">Checkout Sellsy dédié</span>
    </button>
  </div>

  <div class="actions">
    <app-button [outline]="true" type="button" (click)="cancel()" title="Annuler">
      Annuler
    </app-button>
  </div>
</div>
